/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zippy_Vivid_Tern_FlowInputs */

const fr_zippy_vivid_tern_flow = /** @type {(inputs: Zippy_Vivid_Tern_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun programme acquis`)
};

/**

* @param {Zippy_Vivid_Tern_FlowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zippy_vivid_tern_flow = /** @type {((inputs?: Zippy_Vivid_Tern_FlowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zippy_Vivid_Tern_FlowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zippy_vivid_tern_flow(inputs)
});